module.exports = function (isMobile, locale) {
  return {
    navList: [{
      name: 'Whole-Home Backup',
      imgSrc: isMobile ? ['solutions_nav_whole_h5.webp', 'solutions_nav_whole_h5.jpg'] : ['solutions_nav_whole.webp', 'solutions_nav_whole.jpg'],
      detLink: "/".concat(locale, "/whole-home-backup-power-solution")
    }, {
      name: 'Power Kits',
      imgSrc: isMobile ? ['solutions_nav_mm100_h5.webp', 'solutions_nav_mm100_h5.jpg'] : ['solutions_nav_mm100.webp', 'solutions_nav_mm100.jpg'],
      detLink: "/".concat(locale, "/ecoflow-power-kits/series")
    }, {
      name: 'Components',
      icons: '',
      detLink: "https://".concat(locale, ".ecoflow.com/collections/power-kits-components")
    }, {
      name: 'Power Calculator',
      icons: '',
      detLink: "/".concat(locale, "/calculators/power-kits"),
      target: '_blank'
    }],
    content: {
      headerData: [{
        type: 'large',
        name: 'What Are Power Kits?',
        desc: 'Simple. Smart. Compact.',
        imgSrc: isMobile ? ['solutions_bg_h5.webp', 'solutions_bg_h5.jpg'] : ['solutions_bg.webp', 'solutions_bg.jpg'],
        detLink: "/".concat(locale, "/ecoflow-power-kits/series")
      }],
      contextList: [{
        type: 'small',
        name: 'Power Hub',
        desc: '5-in-1 Input and Output Hub',
        imgSrc: isMobile ? ['solutions_list1_h5.webp', 'solutions_list1_h5.jpg'] : ['solutions_list1.webp', 'solutions_list1.jpg'],
        imgHoverSrc: ['solutions_list1_hover.webp', 'solutions_list1_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/power-hub")
      }, {
        type: 'small',
        name: 'LFP Batteries',
        desc: '2–15kWh Storage Capacities',
        imgSrc: isMobile ? ['solutions_list2_h5.webp', 'solutions_list2_h5.jpg'] : ['solutions_list2.webp', 'solutions_list2.jpg'],
        imgHoverSrc: ['solutions_list2_hover.webp', 'solutions_list2_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/lfp-battery")
      }, {
        type: 'small',
        name: 'AC/DC Smart Distribution Panel',
        desc: '6+12 AC/DC Circuits for Your Appliances',
        imgSrc: isMobile ? ['solutions_list3_h5.webp', 'solutions_list3_h5.jpg'] : ['solutions_list3.webp', 'solutions_list3.jpg'],
        imgHoverSrc: ['solutions_list3_hover.webp', 'solutions_list3_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/ac-dc-smart-distribution-panel")
      }, {
        type: 'small',
        name: 'Power Kit Console',
        desc: 'Mount, Monitor and Control',
        imgSrc: isMobile ? ['solutions_list4_h5.webp', 'solutions_list4_h5.jpg'] : ['solutions_list4.webp', 'solutions_list4.jpg'],
        imgHoverSrc: ['solutions_list4_hover.webp', 'solutions_list4_hover.jpg'],
        detLink: "https://".concat(locale, ".ecoflow.com/products/power-kits-console")
      }]
    }
  };
};